export var BusinessType;
(function (BusinessType) {
    BusinessType["ND"] = "ND";
    BusinessType["RESTAURANTS"] = "RESTAURANTES";
    BusinessType["GOURMET"] = "GOURMET";
    BusinessType["SERVICES"] = "SERVICIOS";
    BusinessType["PHARMACY"] = "FARMACIAS";
    BusinessType["HOTEL"] = "HOTEL";
    BusinessType["EXPRESS"] = "EXPRESS";
})(BusinessType || (BusinessType = {}));
export var TypeView;
(function (TypeView) {
    TypeView["SHIPPING"] = "SHIPPING";
    TypeView["COLLECT"] = "COLLECT";
    TypeView["QR"] = "QR";
})(TypeView || (TypeView = {}));
export var InfoTag;
(function (InfoTag) {
    InfoTag["ND"] = "ND";
    InfoTag["PROX"] = "PROXIMAMENTE";
    InfoTag["FREESHIPPING"] = "\u2665 ENVIOS GRATIS \u2665";
    InfoTag["CLOSE"] = "CERRADO";
    InfoTag["DISCOUNT15"] = "DESCUENTO 15%";
    InfoTag["DISCOUNT20"] = "DESCUENTO 20%";
    InfoTag["DISCOUNT30"] = "DESCUENTO 30%";
    InfoTag["DISCOUNT40"] = "DESCUENTO 40%";
    InfoTag["DISCOUNT50"] = "DESCUENTO 50%";
    InfoTag["PROMOCOMBO"] = "PROMOCION EN COMBO";
    InfoTag["SHIPPING1"] = "Envios a $1";
})(InfoTag || (InfoTag = {}));
export default class Menu {
    constructor(id) {
        this.restaurantId = null;
        this.background = null;
        this.logo = null;
        this.description = '';
        this.mainColor = '#feca38';
        this.buttonTextColor = '#000000';
        this.showChefRecommended = true;
        this.showMostSelled = true;
        this.showReviews = false;
        this.name = '';
        this.active = false;
        this.useLogin = false;
        this.localizations = [];
        this.products = [];
        this.categories = [];
        this.ingredients = [];
        this.id = id;
    }
}
